<template>
	<div class="dashboard-student-wrapper container-fluid">
		<div class="row dashboard-student-row">
			<aside :class="showNav ? 'toggled' : ''" class="col-xl-2 col-md-3">
				<div class="container-aside">
					<div class="list-group">
						<div class="text-center logo" @click="showNav = false">
							<img src="../../assets/logo_en_sm.svg" alt="" />
						</div>
						<a
							href="#"
							v-if="$store.state.myProfile.role !== 'student'"
							@click.prevent="goBack"
							class="list-group-item list-group-item-action"
						>
							{{ 'Back' | translate }}
						</a>
						<router-link
							to="/dashboard-student"
							class="list-group-item list-group-item-action"
						>
							{{ 'Dashboard' | translate }}
						</router-link>
						<span
							v-if="false"
							style="color: #fff;"
							class="parents list-group-item list-group-item-action"
						>
							{{ 'For parents' | translate }}
						</span>
						<!-- <router-link to='/dashboard-student/history' class="list-group-item list-group-item-action sub-menu">{{ 'Payment history' | translate }}</router-link> -->
						<router-link
							to="/dashboard-student"
							class="list-group-item green list-group-item-action sub-menu"
							v-if="false"
						>
							{{ 'Pay' | translate }}
						</router-link>
						<router-link
							to="/public_contract"
							class="list-group-item list-group-item-action sub-menu"
						>
							{{ 'Learning contract' | translate }}
						</router-link>
						<router-link
							to="/dashboard-student"
							class="list-group-item list-group-item-action sub-menu"
							v-if="false"
						>
							{{ 'Getting a discount' | translate }}
						</router-link>
						<!-- <router-link to="/games" class="list-group-item primary list-group-item-action">{{ 'Training' | translate }}
						</router-link> -->
						<router-link
							to="/games/abacus-game"
							class="list-group-item list-group-item-action"
						>
							{{ 'Online abacus' | translate }}
						</router-link>
						<a
							href="#"
							@click.prevent="logOut"
							class="list-group-item list-group-item-action"
						>
							{{ 'Logout' | translate }}
						</a>
					</div>
					<Banner />
					<b-button class="btn-language" @click="showLanguageModal = true">
						<i class="fa fa-language" aria-hidden="true"></i>
						{{ $t('Language') }}
					</b-button>
					<b-modal
						size="sm"
						hide-footer
						v-model="showLanguageModal"
						:title="$t('Select language')"
					>
						<a
							v-for="[lng, label] in LANGUAGES"
							:key="lng"
							class="d-block m-auto"
							href="#"
							@click="changeLang(lng)"
						>
							{{ label }}
						</a>
					</b-modal>
				</div>
			</aside>

			<main class="col-xl-10 col-md-9">
				<b-alert class="mt-3" :show="!!profile.notification" variant="info">
					<div class="notification" v-html="profile.notification" />
				</b-alert>

				<div class="main-header">
					<div class="user-block-area">
						<UserBlock :openNav="openNav" />
					</div>

					<div class="nav-block" :class="{ opened: isMobileMenuOpen }">
						<div class="tab-list">
							<div
								class="tab-list-item mobile-btn active"
								@click="openMobileMenu"
							>
								<a>
									{{ activeTabName | translate }}

									<i class="fa fa-bars" aria-hidden="true" />
								</a>
							</div>
						</div>

						<ul class="tab-list mobile-opened">
							<li
								class="tab-list-item"
								:class="{ active: activeRoute === '/dashboard-student' }"
								@click="closeMobileMenu"
							>
								<router-link to="/dashboard-student">
									{{ 'Dashboard' | translate }}
								</router-link>
							</li>

							<li
								class="tab-list-item"
								:class="{
									active: activeRoute === '/dashboard-student/homework',
								}"
								@click="closeMobileMenu"
							>
								<div
									v-if="isReadOnly || $store.state.myProfile.role === 'student'"
								>
									<router-link :to="homeworkLink">
										{{ 'Homework' | translate }}
									</router-link>
								</div>
							</li>

							<li
								class="tab-list-item"
								:class="{ active: activeRoute === '/dashboard-student/shop' }"
								@click="closeMobileMenu"
							>
								<router-link to="/dashboard-student/shop">
									<IconShop />
									<span>{{ 'Shop' | translate }}</span>
								</router-link>
							</li>

							<li
								class="tab-list-item"
								:class="{
									active: activeRoute === '/dashboard-student/training',
								}"
								@click="closeMobileMenu"
							>
								<div
									v-if="isReadOnly || $store.state.myProfile.role === 'student'"
								>
									<router-link to="/dashboard-student/training">
										{{ 'Training' | translate }}
									</router-link>
								</div>
							</li>
						</ul>
					</div>

					<div class="character-area">
						<Character mode="dashboard" />
					</div>
				</div>

				<router-view />
			</main>
		</div>
	</div>
</template>

<script>
import { removeToken } from '../../helpers/token'
import Banner from './Banner'

import UserBlock from '@/components/DashboardStudent/UserBlock'

import Character from '../../components/Games/UI/Character.vue'

export default {
	name: 'student-wrapper',
	data() {
		return {
			showNav: false,
			showLanguageModal: false,
			isMobileMenuOpen: false,
			LANGUAGES: [
				['en', 'English'],
				['ru', 'Русский'],
				['ua', 'Українська'],
				['pl', 'Polski'],
				['he', 'עברית'],
				['az', 'Azərbaycan'],
				['ro', 'Română '],
				['hy', 'հայերեն'],
				['fr', 'Français'],
				['es', 'Español'],
				['cs', 'Czech'],
				['de', 'Deutsch'],
				['it', 'Italiano'],
				['tr', 'Türkçe'],
				['el', 'Ελληνικά'],
			],
		}
	},
	computed: {
		homeworkLink() {
			let link = { name: 'Dashboard Student Homework', query: {} }
			if (this.$route.query.read_only !== undefined) {
				link.query.read_only = this.$route.query.read_only
			}
			return link
		},
		isReadOnly() {
			return this.$route.query.read_only !== undefined
		},
		activeRoute() {
			return this.$route.path
		},
		activeTabName() {
			switch (this.$route.path) {
				case '/dashboard-student':
					return 'Dashboard'

				case '/dashboard-student/shop':
					return 'Shop'

				case '/dashboard-student/training':
					return 'Training'

				case '/dashboard-student/homework':
					return 'Homework'

				default:
					return 'Dashboard'
			}
		},
		profile() {
			return this.$route.query.read_only !== undefined
				? this.$store.state.profile
				: this.$store.state.myProfile
		},
	},
	components: { Banner, UserBlock, Character },
	beforeCreate() {
		if (this.$store.state.myProfile === null) {
			// Update page for catching localStorage data (users`s profile info and token)
			window.location.href = `${window.location.protocol}//${window.location.host}`
		}
	},
	methods: {
		openNav() {
			this.showNav = true
		},

		goBack() {
			if (this.$route.query.read_only) {
				let route = {
					name: this.$route.query.from,
					params: {},
				}
				if (this.$route.query.from === 'Dashboard List') {
					route.params.role = 'student'
				} else {
					route.params.id = this.$route.query.read_only
				}
				this.$router.push(route)
			} else {
				this.$router.push('/')
			}
		},

		logOut() {
			removeToken()
			window.localStorage.removeItem('userProfile')
			this.$store.state.myProfile = null
			this.$router.push({ path: '/' })
		},

		checkPremission() {
			if (this.$route.query.read_only !== undefined) {
				this.axios({
					method: 'get',
					url: `users/user/${this.$route.query.read_only}`,
				}).then(response => {
					this.$store.commit('changeProfile', response.data)
				})
			}
		},

		changeLang(locale) {
			window.localStorage.setItem('defaultLanguage', locale)
			this.$i18n.set(locale)
			this.showLanguageModal = false
		},

		openMobileMenu() {
			this.isMobileMenuOpen = true
		},

		closeMobileMenu() {
			this.isMobileMenuOpen = false
		},
	},
	watch: {
		$route(from, to) {
			this.checkPremission()
		},

		// activeTabName(from, to) {
		// 	this.isMobileMenuOpen = false;
		// }
	},

	created() {
		console.log(this.isActiveTab)

		const lng = localStorage.getItem('defaultLanguage') || this.$i18n.locale()
		if (lng) {
			const [key] = lng && lng.split(',')
			if (key) {
				this.lang = key.toUpperCase()
				this.$i18n.set(key)
				if (this.$i18n.locale() !== lng) {
					this.$i18n.set(key)
				}
			}
		} else {
			let browserLng =
				window.navigator.userLanguage || window.navigator.language
			if (browserLng && typeof browserLng === 'string') {
				const [lowerKey, upperKey] = browserLng.split('-')
				if (this.lngKeys.includes(lowerKey)) {
					this.lang = upperKey
					return
				}
				this.lang = 'RU'
				this.$i18n.set('ru')
			}
		}
		this.checkPremission()

		// reload my profile data
		this.axios({
			method: 'get',
			url: 'users/user/me',
		}).then(response => {
			window.localStorage.setItem('userProfile', JSON.stringify(response.data))
			this.$store.commit('changeMyProfile', response.data)
		})
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.main-header {
	// max-width: 100%;
	// max-height: 400px;
	// display: flex;
	// flex-wrap: wrap;
	// flex-direction: column;

	@media screen and (min-width: 1220px) {
		display: grid;
		grid-template-columns: 80% 20%;

		justify-content: space-between;
		margin: 10px;

		padding-left: 7%;

		margin-top: 0;
	}
}

.dashboard-student-wrapper {
	position: relative;
}

.user-block-area {
	// margin: 10px;
	max-width: 1200px;
	position: relative;
	z-index: 5;

	grid-column: 1;
	grid-row: 1;

	// @media screen and (min-width: 1400px) {
	// 	margin: 10px;
	// }
}

.character-area {
	position: relative;
	// background-color: #fff;

	// border-radius: 8px;
	width: 100%;
	height: 100%;

	min-height: 200px;

	grid-column: 2;
	grid-row-start: 1;
	grid-row-end: 3;

	// margin: auto;

	margin: 0 10px;

	@media (max-width: 767px) {
		min-height: 220px;

		margin-bottom: 30px;
		z-index: 0;
	}
}

.nav-block {
	position: relative;

	max-width: 1200px;

	grid-column: 1;
	grid-row: 2;
}

.tab-list {
	position: relative;

	max-width: 1200px;

	display: flex;
	flex-wrap: wrap;
	justify-content: space-evenly;

	cursor: pointer;

	list-style-type: none;

	z-index: 1;

	margin: auto;
	padding: 0;

	&.mobile-opened {
		@media screen and (max-width: 767px) {
			width: 300px;

			display: none;

			background-color: #ffffff;

			z-index: 9;

			position: absolute;
			left: 50%;
			top: -20px;

			// width: auto;

			box-shadow: 0px 15px 30px rgba(20, 35, 62, 0.15);

			padding: 10px;

			border-radius: 12px;

			transform: translateX(-50%);
		}
	}

	.nav-block.opened &.mobile-opened {
		display: flex;
	}
}

.tab-list-item {
	user-select: none;

	// margin-top: 10px;

	width: 100%;

	text-align: center;
	font-family: 'Montserrat';
	font-style: normal;
	font-weight: 600;
	font-size: em(14);

	@media (max-width: 767px) {
		margin: 2px;
	}

	@media (min-width: 767px) {
		width: calc(50% - 20px);
		margin-top: 6px;
	}

	@media (min-width: 1400px) {
		width: calc(25% - 20px);
		margin-top: 0;
	}

	& a {
		display: block;

		border: 2px solid #fab610;
		border-radius: 12px;

		padding: 12px 5px;
		margin: 0;

		color: #fab610 !important;
		text-decoration: none !important;

		@media (min-width: 767px) {
			padding: 10px 5px;
		}

		@media (min-width: 1400px) {
			padding: 12px 5px;
		}
	}

	& a.router-link-exact-active,
	&.active a {
		background: #fab610;

		color: #fff !important;
	}

	&.mobile-btn {
		display: none;

		@media screen and (max-width: 767px) {
			// width: 220px;
			margin: auto;
			margin-top: 10px;
			display: block;
		}
	}
}

.btn-language {
	// position: absolute;
	// bottom: -60px;
	// left: 0px;
	background: none;
	border: none;
	padding: 20px 10px;
	text-align: left;
	z-index: 11;
	color: #fff;
	font-size: 18px;
}

.dashboard-student-row {
	min-height: 100vh;
}

.container-aside {
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

aside.col-xl-2 {
	padding: 20px 0;
	background-color: #354051;

	overflow: auto;
}

.list-group-item {
	background-color: #354051;
	font-size: 17px;
	color: #949fb2;
	border-top: 1px solid transparent;
	margin-bottom: 1px;
	border-bottom: 1px solid transparent;
}

.list-group-item.green {
	color: green;
}

.list-group-item.green:hover {
	border-color: green;
}

.list-group-item.primary {
	color: #e0a800;
}

.list-group-item.primary:hover {
	color: #e0a800;
	border-color: #e0a800;
	border-left: none;
}

.list-group-item:hover {
	color: #fff;
	border-top-color: #d3d3d3;
	border-bottom-color: #d3d3d3;
}

.list-group-item.game {
	margin-top: 20px;
	color: #f5a338;
}

.game.list-group-item:hover {
	color: #fff;
	border-top-color: #f5a338;
	border-bottom-color: #f5a338;
}

.list-group-item.parents:hover {
	cursor: pointer;
	color: #000;
	border-top-color: transparent;
	border-bottom-color: transparent;
}

.logo {
	margin: 20px 0;
}

.logo img {
	width: 50%;
}

.sub-menu {
	padding-left: 40px;
	display: inline-block;
}

main {
	background-color: #ebf1f5;
}

@media (min-width: 768px) {
	div.mobile-nav {
		display: none;
	}
}

@media (max-width: 767px) {
	aside.col-xl-2 {
		height: 100vh;
		position: fixed;
		overflow: auto;
		top: 0;
		left: -100%;
		z-index: 999;
		transition: 0.5s;
	}

	aside.toggled {
		left: 0;
	}

	.list-group-item {
		justify-content: center;
	}
}
</style>
